import { SimNPC } from '../types/SimNPC';
import { MapTile, ATTRIBUTE_ZONE_TILES } from '../types/GameMap';
import { SimWorld, addLog } from '../types/SimWorld';
import { processMutation, processForbiddenZone } from '../systems/MutationManager';
import type { ExtendedCardData } from '../../utils/cardManager';

// タイル効果定数
const WATER_HEAL = 10; // 水場: HP+10

/**
 * タイル効果を適用
 * - 水場: HP回復
 * - 属性ゾーン: 突然変異チャンス
 */
export function applyTileEffect(
  npc: SimNPC,
  tile: MapTile,
  world: SimWorld,
  allCards?: ExtendedCardData[]
): void {
  switch (tile.type) {
    case 'water':
      // 水場で体力回復
      const oldHP = npc.health;
      npc.health = Math.min(100, npc.health + WATER_HEAL);
      if (npc.health > oldHP && Math.random() < 0.1) {
        addLog(world, `${npc.name}は水場で体力回復（+${npc.health - oldHP}）`);
      }
      break;

    case 'fire_zone':
    case 'water_zone':
    case 'light_zone':
    case 'dark_zone':
    case 'primitive_zone':
    case 'future_zone':
      // 属性ゾーンで突然変異チャンス
      if (allCards && allCards.length > 0) {
        processMutation(npc, tile.type, allCards, world);
      }
      break;

    case 'forbidden_zone':
      // 禁忌の地で禁忌カード獲得チャンス
      if (allCards && allCards.length > 0) {
        processForbiddenZone(npc, allCards, world);
      }
      break;

    case 'food_spot':
    case 'forest':
    case 'grass':
    case 'town':
    case 'mountain':
      // 特に効果なし
      break;
  }
}
